// extracted by mini-css-extract-plugin
export default {"item":"tramites_item__y5Tos","icon":"tramites_icon__wLfAS"};